module.exports = __webpack_public_path__ + "img/RB_Greatsword.d8956771.png";